import { OnDestroy } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { ApplicationFacade } from '@ridango/components';

@Component({
    selector: 'gl-blank-mobile-menu',
    template: ''
})
export class BlankMobileMenuComponent implements OnInit, OnDestroy {
    constructor(private applicationFacade: ApplicationFacade) {}

    ngOnInit(): void {
        this.applicationFacade.setMobileMenuOpen(true);
    }

    ngOnDestroy(): void {
        this.applicationFacade.setMobileMenuOpen(false);
    }
}
